import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { MyAuthService } from 'src/app/core/services/auth.service';
import { map, take, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(private authService: MyAuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    
    // Get roles from route data or default to admin if not specified
    const allowedRoles = next.data?.['allowedRoles'] as string[] || [];
    const allowedPermissions = next.data?.['allowedPermissions'] as string[] || [];
    const permissionCheck = allowedPermissions.length && (this.authService as any).hasAnyPermission
      ? this.authService.hasAnyPermission(allowedPermissions)
      : of(false);
    return this.authService.hasAnyRole(allowedRoles).pipe(
      take(1),
      switchMap(hasRole => hasRole ? of(true) : permissionCheck.pipe(take(1))),
      map(allowed => {
        if (allowed) return true;
        return this.router.createUrlTree(['/']);
      })
    );
  }
}
